// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-page[data-v-4dfe46e2]{align-items:center;display:flex;flex-direction:column;justify-content:center;min-height:100vh;text-align:center}@media(max-width:480px){.error-page[data-v-4dfe46e2]{padding:var(--unit-1200) var(--unit-0400)}}@media(max-width:480px){.error-page__link[data-v-4dfe46e2]{width:100%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
